import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import colores from "../../shared/constants/styles";
import BannerReclamo from "../../assets/images/Banner-Reclamos.png";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { SelectChangeEvent } from "@mui/material/Select";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { postReclamoByClientId } from "../../actions/reclamos";
import { getEstadoPedidoByPresupuestoId } from "../../actions/cuentacorriente";
import { Alert, Stack } from "@mui/material";

const NuevoReclamo = (props) => {
  const localSession = JSON.parse(
    window.localStorage.getItem("LocalSession") || "{}",
  );
  const { idPresupuesto } = useParams();
  const [inicio, setInicio] = useState(true);
  const dispatch = useDispatch();
  const history = useHistory();
  const nroFactura = decodeURIComponent(idPresupuesto);
  const [fileError, setFileError] = useState(false);
  const [formData, setFormData] = useState({
    titulo: "",
    asunto: "",
    descripcion: "",
    nroPedido: decodeURIComponent(idPresupuesto),
    cuit: localSession.documentoNro,
    file: [],
  });

  useEffect(() => {
    dispatch(
      getEstadoPedidoByPresupuestoId(
        localSession.clienteId.trim(),
        decodeURIComponent(idPresupuesto),
      ),
    );
    setInicio(true);
  }, []);

  useEffect(() => {
    console.log(props.estadopedidos);
  }, [props.estadopedidos]);

  const handleChangeTipo = (event: SelectChangeEvent) => {
    setFormData({
      ...formData,
      tipo: event.target.value,
    });
  };

  const handleChangeTitulo = (e) => {
    setFormData({
      ...formData,
      titulo: e.target.value,
    });
  };
  const handleChangeAsunto = (e) => {
    setFormData({
      ...formData,
      asunto: e.target.value,
    });
  };
  const handleChangeDescripcion = (e) => {
    setFormData({
      ...formData,
      descripcion: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      file: e.target.files,
    });
    setFileError(false);
  };

  const handleClick = () => {
    if (!formData.file || formData.file.length === 0) {
      setFileError(true);
      return;
    }
    setFileError(false);
    setInicio(false);
    dispatch(postReclamoByClientId(formData));
  };

  useEffect(() => {
    if (!inicio && props?.success) {
      history.push(`/cuenta-corriente`);
    }
  }, [props]);

  return (
    <div style={{ backgroundColor: colores.grisClaro }}>
      <div style={{ width: "100%" }}>
        {props.loading ? (
          <div style={{ height: "120px" }}></div>
        ) : (
          <img src={BannerReclamo} style={{ width: "100%" }} alt="grupo" />
        )}
        <h1
          style={{
            fontWeight: "bold",
            display: "flex",
            marginTop: "-9vh",
            marginLeft: "1vw",
            fontSize: "45px",
            color: "white",
          }}
        >
          ACOMPANHE SUA RECLAMAÇÃO
        </h1>
      </div>
      {/* <Dolar></Dolar> */}
      <div>
        <div
          className="container-fluid d--flex flex-row mb-3 flex-wrap"
          style={{ backgroundColor: "white", padding: "1rem" }}
        >
          <div
            className="container-fluid"
            style={{
              width: "100%",
              height: "100%",
              overflow: "hidden",
              clear: "both",
            }}
          >
            <div
              className="container d-flex flex-row flex-wrap"
              style={{ marginBlock: "2rem" }}
            >
              <h2
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  fontSize: "35px",
                }}
              >
                Complete o seguinte formulário
              </h2>
            </div>

            <div className="container" style={{ marginBlock: "2rem" }}>
              <div style={{ fontSize: "25px", fontWeight: "bold" }}>NA</div>
              <div>{nroFactura}</div>
            </div>

            <div>
              {Array.isArray(props.estadopedidos) &&
                props.estadopedidos.length > 0 && (
                  <div className="container" style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        background: "white",
                        paddingTop: "2.20rem",
                        paddingBottom: "1.20rem",
                      }}
                    >
                      <div
                        className="row row-cols-12 row-cols-sm-12 row-cols-md-12"
                        style={{ width: "90%" }}
                      >
                        <div
                          className="col"
                          style={{ fontWeight: "bold", maxWidth: "15%" }}
                        >
                          <p style={{ fontSize: "20px" }}>Status</p>
                        </div>
                        <div
                          className="col"
                          style={{ fontWeight: "bold", maxWidth: "5%" }}
                        >
                          <p style={{ fontSize: "20px" }}>Item</p>
                        </div>
                        <div
                          className="col"
                          style={{
                            fontWeight: "bold",
                            maxWidth: "25%",
                            marginLeft: 20,
                          }}
                        >
                          <p style={{ fontSize: "20px" }}>Id producto</p>
                        </div>
                        <div
                          className="col"
                          style={{ fontWeight: "bold", maxWidth: "45%" }}
                        >
                          <p style={{ fontSize: "20px" }}>Producto</p>
                        </div>
                        <div
                          className="col"
                          style={{ fontWeight: "bold", maxWidth: "10%" }}
                        >
                          <p
                            style={{ fontSize: "20px" }}
                            className="text-center"
                          >
                            Quantidade
                          </p>
                        </div>
                      </div>

                      {(Array.isArray(props.estadopedidos)
                        ? props.estadopedidos
                        : []
                      ).map((estadopedido) => (
                        <div
                          key={estadopedido.$id}
                          className="row row-cols-12 row-cols-sm-12 row-cols-md-12"
                          style={{ width: "90%" }}
                        >
                          <div className="col" style={{ maxWidth: "15%" }}>
                            <p style={{ fontSize: "20px" }}>
                              {estadopedido.estado}
                            </p>
                          </div>
                          <div className="col" style={{ maxWidth: "5%" }}>
                            <p style={{ fontSize: "20px" }}>
                              {estadopedido.item}
                            </p>
                          </div>
                          <div
                            className="col"
                            style={{ maxWidth: "25%", marginLeft: 20 }}
                          >
                            <p style={{ fontSize: "20px" }}>
                              {estadopedido.productoId}
                            </p>
                          </div>
                          <div className="col" style={{ maxWidth: "45%" }}>
                            <p style={{ fontSize: "20px" }}>
                              {estadopedido.descripcion}
                            </p>
                          </div>
                          <div className="col" style={{ maxWidth: "10%" }}>
                            <p
                              style={{ fontSize: "20px" }}
                              className="text-center"
                            >
                              {estadopedido.cantidad}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
            </div>

            <div
              className="container d-flex flex-row flex-wrap"
              style={{ marginBlock: "2rem" }}
            >
              <div className="row" style={{ width: "100%" }}>
                <div className="col-6">
                  <div
                    style={{
                      display: "flex",
                      fontSize: "20px",
                      marginTop: "2vw",
                    }}
                  >
                    Título*
                  </div>
                  <FormControl variant="standard" style={{ width: "100%" }}>
                    <InputLabel htmlFor="titulo-reclamo">
                      Título da reclamação
                    </InputLabel>
                    <Input
                      id="titulo-reclamo"
                      type="text"
                      onChange={handleChangeTitulo}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton aria-label="toggle visibility">
                            <DriveFileRenameOutlineIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>
              </div>
            </div>
            <div
              className="container d-flex flex-row flex-wrap"
              style={{ marginBlock: "2rem" }}
            >
              <div className="row" style={{ width: "100%" }}>
                <div className="col-12">
                  <div
                    style={{
                      display: "flex",
                      fontSize: "20px",
                      marginTop: "2vw",
                    }}
                  >
                    Descrição da reclamação*
                  </div>
                  <Box component="form" noValidate autoComplete="off">
                    <TextField
                      style={{ width: "100%" }}
                      id="descripcion-reclamo"
                      onChange={handleChangeDescripcion}
                      multiline
                      rows={2}
                      variant="standard"
                    />
                  </Box>
                </div>
              </div>
            </div>
            <div
              className="container d-flex flex-row flex-wrap"
              style={{ marginBlock: "2rem" }}
            >
              <div className="row" style={{ width: "100%" }}>
                <div className="col-6">
                  <div
                    style={{
                      display: "flex",
                      fontSize: "20px",
                      marginTop: "2vw",
                    }}
                  >
                    Preciso anexar imagens ou arquivos
                  </div>
                  <input
                    id="file-input"
                    type="file"
                    multiple
                    style={{
                      border: "1px solid #ccc",
                      display: "inline-block",
                      padding: "6px 12px",
                      cursor: "pointer",
                      borderRadius: "5px",
                      marginTop: "16px",
                    }}
                    onChange={handleFileChange}
                  />
                  {fileError && (
                    <Alert severity="error" style={{ marginTop: 20 }}>
                      Deve anexar pelo menos um arquivo.
                    </Alert>
                  )}
                </div>

                <div className="col-6" style={{ marginTop: "7.4vh" }}>
                  <Button
                    className="my-3"
                    style={{
                      backgroundColor: colores.rojo,
                      color: "#fff",
                      float: "right",
                    }}
                    variant="contained"
                    onClick={() => handleClick()}
                    type="button"
                  >
                    ENVIAR
                  </Button>
                </div>
              </div>
            </div>
            {props?.error ? (
              <div
                className="container d-flex flex-row flex-wrap"
                style={{ marginBlock: "2rem" }}
              >
                <div className="row" style={{ width: "100%" }}>
                  <div className="col-12">
                    <p style={{ color: "red" }}>
                      Erro ao criar a reivindicação. Tente novamente mais tarde.
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default connect(
  (state) => ({
    estadopedidos: state.cuentacorriente.estadopedidos,
    reclamos: state.reclamos.reclamos,
    success: state.reclamos.success,
    loading: state.reclamos.loading,
    error: state.reclamos.error,
  }),
  (dispatch) => ({
    postReclamoByClientId: (reclamo) =>
      dispatch(postReclamoByClientId(reclamo)),
    getEstadoPedidoByPresupuestoId: (clienteId, presupuestoId) =>
      dispatch(getEstadoPedidoByPresupuestoId(clienteId, presupuestoId)),
  }),
)(NuevoReclamo);
